import React, { useEffect, useCallback, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BaseHomePage from "../pages/BasePage";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Box,
  Backdrop,
  CircularProgress,
} from "@mui/material";

export default function HomePage() {
  const navigation = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState({
    name: String(),
    email: String(),
  });

  const sendRegister = useCallback(async () => {
    try {
      const endpoint = `${process.env.REACT_APP_HOST}/public-events`;
      let response = await axios.post(endpoint, {
        name: data.name,
        email: data.email,
        event: "DIVERGENTES-2023",
      });
      if (response.data.code === Number()) {
        console.log("GOOD");
        localStorage.setItem("needRegister", false);
        localStorage.setItem("registered", true);
        navigation("/");
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    } finally {
      setOpen(Boolean());
    }
  }, [navigation, data]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setOpen(true);
    sendRegister();
  };

  const handleTextChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const renderView = () => {
    let view = (
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3} maxWidth="md" sx={{ m: "auto" }}>
          <Grid item xs={12}>
            <Typography variant="h1">{"Registro"}</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              name="name"
              placeholder="Nombre"
              type="name"
              value={data.name}
              onChange={handleTextChange}
            ></TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              name="email"
              placeholder="Email"
              type="email"
              value={data.email}
              onChange={handleTextChange}
            ></TextField>
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" type="submit">
              {"ENTRAR"}
            </Button>
          </Grid>
        </Grid>
      </Box>
    );
    return view;
  };

  useEffect(() => {
    if (localStorage.getItem("registered") === "true") {
      navigation("/");
    } else {
      localStorage.setItem("needRegister", true);
    }
  });

  return (
    <BaseHomePage>
      {renderView()}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </BaseHomePage>
  );
}
